import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import * as $ from 'jquery';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q13',
  templateUrl: './r-q13.component.html',
  styleUrls: ['./r-q13.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ13Component implements OnInit {
  @Input() data: any;
  question;
  questions;
  userResponses = [];
  index;
  questionObj;
  years = ['After 2015', '2011 - 2015', '2006 - 2010', '2001 - 2005', '1996 - 2000', '1991 - 1995',
    '1986 - 1990', '1981 - 1985', '1976 - 1980', '1971 - 1975', '1966 - 1970', '1961 - 1965', '1956 - 1960',
    '1951 - 1955', '1946 - 1950', '1941 - 1945', 'Prior to 1940'];
  age;
  property;
  messagetype;
  deviceWidth;
  user_bot;
  disablebutton = false;
  showbutton = true;
  timer;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.property = this.residentialService.property;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ 'nextId': '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (!_.isEmpty(this.property)) {
      if (this.property === 'Apartment or condominium') {
        this.question = this.question.replace('home', 'apartment');
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.disablebutton = true;
        this.age = obj.fieldValue;
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    if (_.isEmpty(this.age))
    {
      this.showbutton = false;
    }

    if(this.deviceWidth < 768)
    {
      setTimeout(function(){

        $('ng-select:visible').find('.ng-input').find('input').on('focus', function() { $(this).blur(); });
  
      },500)
    }

  }

  getAge(event) {
    this.disablebutton = true;
    this.age = event;
    if (this.deviceWidth < 768) {
      this.residentialService.unSelectService({'currentId': this.data});
    }
    this.user_bot = true;
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if(!this.showbutton)
      {
        this.next();
      }
    }
  }
  
  next() {
    if (_.isEmpty(this.age)) {
      // console.log.log('age', this.age);
      // alert('Select the Year');
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data,
      'fieldName': 'home_age',
      'fieldValue': this.age
    };
    this.residentialService.updateResponses(Obj);
  }
}
